import React from 'react';
import {
  Container,
  Header,
  SpaceBetween,
  Button,
  FormField,
  RadioGroup,
} from '@cloudscape-design/components';
import { getProgramFeedbackConfig } from '../programs/registry';

// Blind review samples MAP fund requests only, and the label Lambda accepts
// exactly MAP's three decision values, so the choices and the reveal label
// both come from MAP's feedback config.
const DECISION_OPTIONS = getProgramFeedbackConfig('MAP').decisionOptions;

export const blindDecisionLabel = (value) =>
  DECISION_OPTIONS.find((option) => option.value === value)?.label || value;

// Controlled by FundingRequestDetail, which owns the state. Every reload of that
// page swaps it for a spinner and unmounts this form, including the second
// reload 15 s after a validation completes, so state kept here would be lost.
// No free-text reason: a blind label keeps the decision alone (batpur,
// 2026-10-14, Q-1014-3). After the label, the page shows the answer and the
// regular feedback panel.
const BlindReviewForm = ({ decision, submitting, onDecisionChange, onSubmit }) => {
  return (
    <Container
      header={
        <Header
          variant="h2"
          description="Chronos has validated this fund request and is holding its result until a reviewer records their own decision. Review the request here and in APFP, then choose a decision. It cannot be changed after you submit."
        >
          Blind review
        </Header>
      }
    >
      <SpaceBetween size="m">
        {/* A radio group, so a screen reader hears which decision is selected (WCAG 2.1 SC 4.1.2). */}
        <FormField label="Your decision">
          <RadioGroup
            value={decision}
            onChange={({ detail }) => onDecisionChange(detail.value)}
            items={DECISION_OPTIONS.map((option) => ({ value: option.value, label: option.label, disabled: submitting }))}
          />
        </FormField>
        <Button
          variant="primary"
          onClick={onSubmit}
          loading={submitting}
          disabled={!decision || submitting}
        >
          Submit
        </Button>
      </SpaceBetween>
    </Container>
  );
};

export default BlindReviewForm;
